// Can be used in certain cases where $nextTick() isn't allowed
// Reference: https://gitlab.delfi.net/ee/portal/portal-root/-/merge_requests/1504#note_818198
export const resolvePromises = () => new Promise((resolve) => setTimeout(resolve, 0));
